/*
 * Customer view
 */
function r(t, r) {
  return Math.floor(Math.random() * (r - t + 1) + t);
}
var variation = 800,
  c = r(500, 2000);

$("#counter").text(c);
$("#counter1").text(c);

setInterval(function () {
    var t = r(-variation, variation);
    c += t;
    
    // Ensure #counter1 stays between 250 and 800
    c = Math.max(250, Math.min(c, 800));
    
    $("#counter").text(c);
    $("#counter1").text(c);
}, 3000);

/*
 * Product page sticky add to cart
$(function () {
  if ($(".kit-product-template")[0]) {
    var z = $(".kit-product-template").offset().top + $(".kit-product-template").outerHeight();
    $(document).scroll(function () {
      var y = $(this).scrollTop();
      if (y > z) {
        $(".wrapper-selection.add-to-cart").addClass("wrapper-selection-fixed-ATC");
      } else {
        $(".wrapper-selection.add-to-cart").removeClass("wrapper-selection-fixed-ATC");
      }
    });
  }
});
*/

$(window).scroll(function(){
  if ($(this).scrollTop() > 500) {
     $('.image-wrapper-list.product-image').addClass('change_position');
  } else {
     $('.image-wrapper-list.product-image').removeClass('change_position');
  }
});
/*
 * Product page tap button
 */
function setTapBox() {
  var get_tabbox = localStorage.getItem("TapBox");
  if (get_tabbox == "Clicked") {
    $(".tap-click-view").hide();
    $(".tap-hover-view").show();
    $('.kit-product-annoucement').show();
    $('body').addClass('show-annoucement');
    
  } else {
    $(".tap-click-view").show();
    $(".tap-hover-view").hide();
    $('.kit-product-annoucement').hide();
    $('body').removeClass('show-annoucement');
  }
}

// $(document).ready(function () {
//   setTapBox();
//   //$('.kit-v1 .info-bar').attr('style','display: block !important');
//   $(".tap-click-view").click(function () {
//     localStorage.setItem("TapBox", "Clicked");
//     setTapBox();
//   });
// });

// ============== Kit product sticky bar increase product quantity according to price ================
jQuery(document).ready(function () {

    function updatePrice(input) {
        let newVal = parseInt(input.val());
        if (isNaN(newVal) || newVal < 1) newVal = 1;
        input.val(newVal); // sanitize input

        const selectedOption = $(".kit-option-label.selected");
        const pricePerUnit = parseInt(selectedOption.attr('data-compareprice')) || 0;
        const mainPrice = parseInt(selectedOption.attr('data-mainprice')) || 0;
        const productName = selectedOption.attr('data-value');

        const totalPrice = newVal * pricePerUnit;
        const mainPriceTotal = newVal * mainPrice;
        const discountPrice = totalPrice - mainPriceTotal;

        const moneyFormat = $('html').attr('data-money-format');
        const formattedMainPrice = Shopify.formatMoney(mainPriceTotal, moneyFormat);
        const formattedComparePrice = Shopify.formatMoney(totalPrice, moneyFormat);

        const container = input.closest('.custom-stick-container');
        container.find('.pricing-package').text(formattedMainPrice);
        container.find('.cross-through').text(formattedComparePrice);
        container.find('.disc-saving span').text(discountPrice); // You may want to format this too

        console.log("Quantity:", newVal);
        console.log("Product Name:", productName);
        console.log("Unit Prices - Main:", mainPrice, "Compare:", pricePerUnit);
        console.log("Total Prices - Main:", mainPriceTotal, "Compare:", totalPrice);
    }

    function changeQuantity(button, increment) {
        const fieldName = button.attr('field');
        const input = $(`input[name=${fieldName}]`);
        let currentVal = parseInt(input.val());

        currentVal = isNaN(currentVal) ? 1 : currentVal + increment;
        if (currentVal < 1) currentVal = 1;

        input.val(currentVal);
        updatePrice(input);
    }

    $('.qtyplus').click(function (e) {
        e.preventDefault();
        changeQuantity($(this), 1);
    });

    $('.qtyminus').click(function (e) {
        e.preventDefault();
        changeQuantity($(this), -1);
    });

    $(document).on("change", ".quanitty", function () {
        updatePrice($(this));
    });

    // On page load
    $(".quanitty").each(function () {
        updatePrice($(this));
    });

});
//  ============== END Kit product sticky bar increase product quantity according to price ================


$(document).ready(function(){
 $('body.kit-v1 .kit-option-label').click(function(){
   var kit_comp_price = $(this).attr('data-vprice');
   $('body.kit-v1 .cross-price-was .cross-through').html(kit_comp_price);
   var kit_d_price = $(this).attr('data-dprice');
   $('body.kit-v1 .kit-disc-price').html(kit_d_price);
   $('body.kit-v1 #product-price-selectorr').html(kit_d_price);

   var comp_price = $(this).attr('data-compare-at-price');
   $('.kit-product-v3 .cross-price-was .cross-through').html(comp_price);
   var kit_variant_price = $(this).attr('data-variant-price');
   $('.kit-product-v3 .kit-disc-price').html(kit_variant_price);
   $('.kit-product-v3 #product-price-selectorr').html(kit_variant_price);
   
   var kit_a_price = $(this).attr('data-aprice');
   $('body.kit-v1 .cs-price-afterpay').html(kit_a_price);
   
   if($(this).attr('data-value')) {
     $('.pro-title .pop-image-title').html($(this).attr('data-value'));
   }
   if($(this).attr('data-save-percentage')) {
     $('.saving-price-btn .save-percentage').html($(this).attr('data-save-percentage'));
   }
   if($(this).attr('data-saving-price')) {
     $('.saving-price-wrapper .saving-price, .saving-price-btn .saving-price').html($(this).attr('data-saving-price'));
   }
   if($(this).attr('data-save-price')) {
     $('body.kit-v1 .disc-saving .saving-price').html($(this).attr('data-save-price'));
   }
 }); 

 $('body.colour-v1 .kit-option-label').click(function(){
   var kit_comp_price_c = $(this).attr('data-vprice');
   $('body.colour-v1 .cross-price-was .cross-through').html(kit_comp_price_c);
   var kit_d_price_c = $(this).attr('data-dprice');
   $('body.colour-v1 .kit-disc-price').html(kit_d_price_c);
   $('body.colour-v1 #product-price-selectorr').html(kit_d_price_c);
   var kit_a_price_c = $(this).attr('data-aprice');
   $('body.colour-v1 .cs-price-afterpay').html(kit_a_price_c);
   var kit_c_price_c = $(this).find('#var-save-off').val();
   $('body.colour-v1 .cs-colo-dprice').html(kit_c_price_c);
 });
});

/* Fancybox on product image */
$(document).ready(function(){
$('[data-fancybox="gallery1"]').fancybox({
  loop: true
});
$('[data-fancybox="gallery2"]').fancybox({
  loop: true
});
});
/* Preshape modals */
$(document).ready(function(){
  $('.cs-preshape-toggle').on('click', function(e) {
    e.preventDefault();
    $('.cs-preshape-modal').toggleClass('is-visible');
    $('.cs-preshape-toggle .custom-add-check i').css("display", "none");
    $('.cs-preshape-toggle #negletipper').removeAttr("checked");
  });
});
/* Preshape modals option change */
jQuery(document).ready(function(){
  jQuery('.cs-preshape-content [data-product-option-indexes] input[type=radio]').change(function() {
    var optionIndex = jQuery(this).closest('.cs-preshape-content [data-product-option-indexes]').attr('data-product-option-indexes');
    var optionValue = jQuery(this).val();
    jQuery(this).closest('.cs-preshape-content [data-product-option-indexes]').find('.variation-element').removeClass('selected');
    jQuery(this).closest('label').addClass('selected');
    jQuery(this).closest('.cs-preshape-content').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    jQuery(this).closest('.cs-preshape-content').find('.w-selects').eq(optionIndex).val(optionValue);
    var sel_dta = jQuery(this).closest('.cs-preshape-content').find('.w-selects option:selected').attr('data-val');
    var sel_dta_img = jQuery(this).closest('.cs-preshape-content').find('.w-selects option:selected').attr('data-image');
    //console.log(sel_dta);
    jQuery('input#negletipper').attr('data-vid', sel_dta);
    if(sel_dta_img) {
     jQuery(this).closest('.cs-preshape-content').find('.cs-main-image-model').attr('src', sel_dta_img);  
   } else {
     jQuery(this).closest('.cs-preshape-content').find('.cs-main-image-model').attr('src', 'https://cdn.shopify.com/s/files/1/0704/4943/0787/files/Losnaglar_photo_2_1.png?v=1721039398');  
   }
  });
});
/* Preshape modals button click */
 jQuery(document).ready(function(){
   $('.cs-preshape--btn').click(function(){
      $('.cs-preshape-modal').toggleClass('is-visible');
      $('.cs-preshape-toggle .custom-add-check i').css("display", "flex");
      $('.cs-preshape-toggle #negletipper').attr("checked", "checked");     
   });
 });

/* remove modals button click */
jQuery(document).ready(function(){
  $('.cs-removeSo-toggle').on('click', function(e) {
    e.preventDefault();
    var handle = $(this).attr('data-handle');
    $('.cs-removeSo-modal').attr('data-handle', '');
    if($(this).hasClass("stop-popup-toggle")) {
      // console.log("stop-popup-toggle TRUE");
      if($('.cs-removeSo-toggle #dippulverborttagning').is(':checked')) {
        $('.cs-removeSo-toggle .custom-add-check i').css("display", "none");
        $('.cs-removeSo-toggle #dippulverborttagning').attr("checked", false);  
      } else {
        $('.cs-removeSo-toggle .custom-add-check i').css("display", "flex");
        $('.cs-removeSo-toggle #dippulverborttagning').attr("checked", "checked");
      }
    } else {
      // console.log("stop-popup-toggle FALSE");
      $('.cs-removeSo-modal').toggleClass('is-visible');
      $('.cs-removeSo-toggle .custom-add-check i').css("display", "none");
      $('.cs-removeSo-toggle #dippulverborttagning').removeAttr("checked");
      $('.cs-removeSo-modal').attr('data-handle', handle);
      $('.cs-removeSo-content[data-content="'+ handle +'"]').css("display", "block");
    }
  });
  $('.cs-removeSo--btn').click(function(){
    var variant_id = $('.cs-removeSo-modal input[type="radio"]:checked').attr('data-variant-id');
    $('.cs-removeSo-toggle #dippulverborttagning').attr("data-vid", variant_id).attr("checked", "checked");
    $('.cs-removeSo-modal').toggleClass('is-visible');
    $('.cs-removeSo-toggle .custom-add-check i').css("display", "flex");
  });
});


/* Update product available url query string varinat id */
function updateQueryString(key, value, url) {
  if (!url) url = window.location.href;
  let updated = ''
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;

  if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null) {
        updated = url.replace(re, '$1' + key + "=" + value + '$2$3');
      }  else {
        hash = url.split('#');
        url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
        if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
          url += '#' + hash[1];
        }
        updated = url;
      }
  } else {
    if (typeof value !== 'undefined' && value !== null) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      hash = url.split('#');
      url = hash[0] + separator + key + '=' + value;
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1];
      }
      updated = url;
    } else {
      updated = url;
    }
  }
  window.history.replaceState({ path: updated }, '', updated);
}

$(document).ready(function(){
  var get_selected_var = $('.custom-cm-inp').val();
  updateQueryString('variant', get_selected_var);
});

/* include kit modals */
$(document).ready(function(){
  var startkit_totalprice = 921;
  var complettkit_totalprice = 1308;
  var ultimatkit_totalprice = 1566;
  
  $('.include-kit-toggle').on('click', function(e) {
    e.preventDefault();
    var dataKit = $(this).data('kit');
   $('.include-kit-modal .include-kit-value').css('display', 'none');
    if (dataKit === 'Start KIT') {
      $('.include-kit-modal .include-kit-value[data-kit="Start Kit"] .total-value .value').html(startkit_totalprice + ' kr');
      $('.include-kit-modal .include-kit-value[data-kit="Start Kit"]').css('display', 'block');
    } else if (dataKit === 'Komplet KIT') {
      $('.include-kit-modal .include-kit-value[data-kit="Komplet Kit"] .total-value .value').html(complettkit_totalprice + ' kr');
      $('.include-kit-modal .include-kit-value[data-kit="Komplet Kit"]').css('display', 'block');
    } else if (dataKit === 'Ultimat KIT') {
      $('.include-kit-modal .include-kit-value[data-kit="Ultimat Kit"] .total-value .value').html(ultimatkit_totalprice + ' kr');
       $('.include-kit-modal .include-kit-value[data-kit="Ultimat Kit"]').css('display', 'block');
    }
    $('.include-kit-modal').toggleClass('is-visible');
  });
});

/* ==================== Kit New Landing Page Offer countdown time JS ==================== */

$(document).on("click", ".custom-cta", function () {
  var headerHeight = $(window).width() <= 789 ? 10 : $(".header").outerHeight() + 10;
  var OfferContentHeight = $(window).width() <= 789 ? 10 : $(".offer-content .offer-content-wrapper").outerHeight();
  var offerContentHeight = $(".offer-content .offer-content-wrapper").length ? $(".offer-content .offer-content-wrapper").outerHeight() : 0;
  var totalOffset = headerHeight + offerContentHeight;
  
  var targetElement = $(".kit-product-v3 ._custom-color-main");
  if (targetElement.length) {
    $("html, body").animate({
      scrollTop: targetElement.offset().top - totalOffset
    }, 800);
  }
});

// Specific Date timer
function updateCountdown() {
  let endTimeString = document.querySelector(".offer-content-wrapper").getAttribute('data-countdown-time');
  let endTime = new Date(endTimeString).getTime();
  let daysContainer = document.querySelector(".days-container");
  let now = new Date().getTime();
  let timeLeft = endTime - now;
  if (timeLeft <= 0) {
    document.querySelector(".offer-content-wrapper").innerHTML = document.querySelector(".offer-content-wrapper").getAttribute('data-expired-message');
    return;
  }
  let days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  let hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
  let seconds = Math.floor((timeLeft / 1000) % 60);
  if (daysContainer) {
   if (days === 0) {
      daysContainer.classList.add("hidden");
    } else {
      daysContainer.classList.remove("hidden");
    }
  }
  document.getElementById("days").innerText = days.toString().padStart(2, '0');
  document.querySelector(".days-label").innerText = days === 1 ? "Day" : "Days";
  document.getElementById("hours").innerText = hours.toString().padStart(2, '0');
  document.getElementById("minutes").innerText = minutes.toString().padStart(2, '0');
  document.getElementById("seconds").innerText = seconds.toString().padStart(2, '0');

  setTimeout(updateCountdown, 1000);
}
$(document).ready(function(){
  if(document.querySelector(".offer-content-wrapper:not(.auto-timer-active) .countdown-timer")) {
    updateCountdown();
  }
});
  
// 15 hours Auto timer
function startCountdown() {
  console.log("started timer")
  let offerWrapper = document.querySelector(".offer-content-wrapper.auto-timer-active");
  let timerElement = {
    hours: document.getElementById("hours"),
    minutes: document.getElementById("minutes"),
    seconds: document.getElementById("seconds"),
  };
  
  function getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, hours) {
    let expires = new Date();
    expires.setTime(expires.getTime() + (hours * 60 * 60 * 1000));
    document.cookie = name + "=" + value + "; path=/; Secure; SameSite=None; expires=" + expires.toUTCString();
  }

  function updateTimer() {
    let now = new Date().getTime();
    let endTime = Number(getCookie("countdownTimer"));
    
    if (!endTime || now >= endTime) {
      endTime = now + 54000000; // 15 hours from now
      setCookie("countdownTimer", endTime, 24);
      // console.log("New countdown started for 15 hours.");
    }

    let distance = endTime - now;
    if (distance <= 0) {
      setCookie("countdownTimer", now + 54000000, 24);
      // console.log("New countdown started for 15 hours.");
      updateTimer();
      return;
    }
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    timerElement.hours.innerText = hours.toString().padStart(2, '0');
    timerElement.minutes.innerText = minutes.toString().padStart(2, '0');
    timerElement.seconds.innerText = seconds.toString().padStart(2, '0');
  }
  
  updateTimer();
  setInterval(updateTimer, 1000);
}
$(document).ready(function(){
  if(document.querySelector(".offer-content-wrapper.auto-timer-active .countdown-timer")) {
    startCountdown();
  }
});
/* ==================== End Kit New Landing Page Offer countdown time JS ==================== */

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('.custom-play-button');
    // console.log("Click the Button poster::", poster);
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    // console.log("Click the Button poster loadContent::", this);
    document.querySelectorAll('.pro-images video').forEach((video) => video.pause());
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play();
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

$(document).on("click", ".product-media-modal .product-media-modal__toggle", function (e) {
  e.preventDefault();
  let $modal = $(this).closest(".product-media-modal");
  if ($modal.length) {
    $modal.removeAttr("open");
  }
});
$(document).on("click", ".product-media-modal .custom-play-button", function (e) {
  $('.pro-images video').each(function () {
    this.pause();
  });
  let $deferredContainer = $(this).closest('.deferred-media');
  if (!$deferredContainer.attr('loaded')) {
    $(this).removeClass('show-play-btn');
    let $template = $deferredContainer.find('template');
    if (!$template.length) return;
    let content = $('<div>').append($template.html());
    $deferredContainer.attr('loaded', true);
    let $deferredElement = $deferredContainer.append(content.find('video, model-viewer, iframe').first());
    $deferredElement.trigger('focus');
    if ($deferredElement.is('video') && $deferredElement.attr('autoplay')) {
      $deferredElement[0].play();
    }
    $("video.kit-main-media").on("pause ended", function () {
      $(this).siblings(".custom-play-button").addClass('show-play-btn');
    });
  } else {
    let $video = $deferredContainer.find("video").first();
    if ($video.length) {
      if ($video[0].paused) {
        $(this).removeClass('show-play-btn');
        $video[0].play();
      } else {
        $(this).addClass('show-play-btn');
        $video[0].pause();
      }
    }    
  }
});

$("video.kit-main-media").on("pause ended", function () {
  $(this).siblings(".custom-play-button").addClass('show-play-btn');
});
  
document.querySelectorAll('.thumbnail-image-wrapper .media-wrap').forEach(button => {
  button.addEventListener('click', function() {
    const mediaWrap = this.closest('.media-wrap');
    const mobileWrap = this.closest('.kit-mob-only');
    const slickIndex = this.getAttribute('data-slick-index');
    if(!slickIndex) return;
    const mainSlide = mobileWrap ? document.querySelector('.kit-pro-thumb .slick-slide[data-slick-index="'+ slickIndex +'"]') : document.querySelector('.main-pro-images .slick-slide[data-slick-index="'+ slickIndex +'"]');
    // console.log("mainSlide:: ", mainSlide);
    if(!mainSlide) return;
    const deferredMedia = mainSlide.querySelector('.deferred-media');
    if (deferredMedia) deferredMedia.loadContent(false);
  });
});

$(document).on("click", ".kit-product-v3 .kit-pro-thumb .kit-pro-thumb-inner", function (e) {
  e.preventDefault();
  let mediaId = $(this).attr("data-media-id");
  let modal = document.querySelector('.kit-product-v3 + .product-media-modal');
  if (modal) {
    let targetMedia = modal.querySelector(`[data-media-id="${mediaId}"]`);
    if (targetMedia) {
      // console.log("Scrolling to media:",mediaId, targetMedia, targetMedia.offsetTop);
      modal.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
      targetMedia.classList.add('is-active');
      modal.querySelector('.product-media-modal__content').scrollTop = targetMedia.offsetTop;
    }
    modal.setAttribute("open", "true");
  }
});